export default function calcDaysHire(hireDate, returnDate) {
  const differenceMilliseconds = returnDate.getTime() - hireDate.getTime()
  return Math.ceil(differenceMilliseconds / (1000 * 3600 * 24)) + 1
}
